import {
  ProductDetailRecord,
  ProductGenderStringEnum,
  ProductSeasonEnum,
} from '@features/halalShop/store/types';

export const IS_DISABLED_TO_CHANGE = false;

export const seasonSelectOptions = [
  {
    label: 'Межсезон',
    value: ProductSeasonEnum.DemiSeason,
  },
  {
    label: 'Лето',
    value: ProductSeasonEnum.Summer,
  },
  {
    label: 'Зима',
    value: ProductSeasonEnum.Winter,
  },
];

export const temp_initialValues: ProductDetailRecord = {
  brand: null,
  category: null,
  certificate: null,
  consist: '',
  description: '',
  ext_id: '',
  gender: ProductGenderStringEnum.Male,

  id: 0,
  image: null,
  is_active: true,
  is_new: true,
  manufacturer: '',
  name: '111',
  offers: [],
  params: null,
  photos: [],
  price: { currency: 'RUB', value: 1000 },
  price_old: null,
  product_color: null,
  quantity: 1,
  season: null,
  shipping: false,
  show_always: true,
  sku: '',
  video: '',
};
